import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { IconName } from "@/components/icons/registry"

export function useExtendedAccessBenefits() {
	const { t } = useI18n()

	return computed(() => [
		{ key: "parcelDetails", label: t("extendedAccess.benefits.parcelDetails"), icon: IconName.FileText },
		{ key: "layers", label: t("extendedAccess.benefits.layers"), icon: IconName.Layers },
		{ key: "regulatoryAssistant", label: t("extendedAccess.benefits.regulatoryAssistant"), icon: IconName.Sparkles },
	])
}
